import { useTranslation } from "react-i18next";
import { chooseLocale } from "../i18n";
import { LANGUAGE_NAMES, LOCALES } from "../i18n/locale";
import { cx } from "./ui";

/**
 * The language picker, as a row of names rather than a select: two languages
 * fit on one line, and a select for two options is a tap to reveal a tap. It
 * lives in the footer here -- this shell has no account menu -- and on the
 * sign-in page, so it is reachable signed out too. The choice is written to
 * the cookie the marketing site and the customer dashboard read, so the
 * three surfaces agree from then on.
 */
export function LanguageSwitch({ className }: { className?: string }) {
  const { t, i18n } = useTranslation("common");
  return (
    <div className={cx("flex items-center gap-1", className)} role="group" aria-label={t("language")}>
      {LOCALES.map((locale) => (
        <button
          key={locale}
          type="button"
          lang={locale}
          aria-current={locale === i18n.language ? "true" : undefined}
          onClick={() => void chooseLocale(locale)}
          className={cx(
            "rounded px-1.5 py-0.5 transition-colors duration-200 ease-smooth hover:text-fg",
            locale === i18n.language ? "text-fg" : "text-fg-subtle",
          )}
        >
          {LANGUAGE_NAMES[locale]}
        </button>
      ))}
    </div>
  );
}
